// extracted by mini-css-extract-plugin
export var backupIcon = "_mt-1";
export var image = "_mt-0";